import { KYCData } from 'types';
import { fetchAPI } from './fetchAPI';

export const fetchKYCData = async (receiveOrderPreviewId?: string) => {
  return await fetchAPI<KYCData>(
    'kyc' +
      (receiveOrderPreviewId
        ? `?receive-order-preview-id=${receiveOrderPreviewId}`
        : '')
  );
};
